import { objectOf } from "@altostra/type-validations";

export const isDeleteCdiSegmentsConfigResult = objectOf({});
